import { render, staticRenderFns } from "./HeaderOldUI.vue?vue&type=template&id=1a32206a&scoped=true&"
import script from "./HeaderOldUI.vue?vue&type=script&lang=js&"
export * from "./HeaderOldUI.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOldUI.vue?vue&type=style&index=0&id=1a32206a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32206a",
  null
  
)

export default component.exports